// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__7pPPY","colMin":"styles_colMin__3pOuf","colCheckbox":"styles_colCheckbox__3vr8h"};